import { render, staticRenderFns } from "./MapPinIcon.vue?vue&type=template&id=018b9a4f"
import script from "./MapPinIcon.vue?vue&type=script&lang=js"
export * from "./MapPinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports